import { BlockStack, Card, Link, Text } from "@shopify/polaris";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const MustRead = () => {
  const [storeSettings, setStoreSettings] = useState({
    country: "",
    language: "",
    currency: "",
  });
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const paramValue = urlParams.get("shop");

        // Fetch store settings
        const settingsResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/store/settings?shop=${paramValue}`
        );
        const settingsData = await settingsResponse.json();

        // Fetch active markets
        const marketsResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/active-markets?shop=${paramValue}`
        );
        const marketsData = await marketsResponse.json();

        if (settingsData.data && marketsData.data?.markets) {
          const settings = settingsData.data;
          const primaryMarket = marketsData.data.markets.primaryMarket;

          setStoreSettings({
            country: settings.primaryTargetCountry || "Pakistan",
            language: settings.contentLanguage || "ENGLISH",
            currency: primaryMarket?.handle?.toUpperCase() || "PKR",
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [location]);

  return (
    <div>
      <Card>
        <BlockStack gap="400">
          <Text variant="headingXl" fontWeight="semibold" as="h5">
            Very Important and<span style={{ color: "red" }}> Must Read </span>
            before using additional countries feed feature.
          </Text>
          <div>
            <Text variant="headingMd" as="h6">
              Default Currency of the Store : {storeSettings.currency}
            </Text>
            <Text variant="headingMd" as="h6">
              Default Language of the content on the store :{" "}
              {storeSettings.country} ({storeSettings.language})
            </Text>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              rowGap: "8px",
              padding: "0 15px",
            }}
          >
            <Text variant="bodyMd" as="p">
              1. To begin, add one or two additional countries and ensure your
              products receive approval before expanding further. Avoid adding
              more than two countries initially. Once you've successfully
              completed this process, you can expand your reach to all available
              countries based on your store’s language settings. However, it is
              recommended to first gain experience by setting up a limited
              number of additional countries.
            </Text>
            <Text variant="bodyMd" as="p">
              2. For details on submitting product feeds to different countries
              and understanding their language requirements, please refer to the
              provided help link. This document should be used exclusively for
              language-specific requirements. Regarding currency compatibility,
              Google Merchant Center's built-in currency converter will be
              applied. Add this link to the word Link here above
              https://support.google.com/merchants/answer/160637?hl=en
            </Text>
            <Text variant="bodyMd" as="p">
              3. Your product feed can only be submitted in the countries listed
              under the "Manage Additional Countries" section, based on the
              language of your store’s content.{" "}
              <span style={{ fontWeight: "bold" }}>
                Manage Additional Countries
              </span>{" "}
              Section.
            </Text>
            <Text variant="bodyMd" as="p">
              4. The Google Shopping Feed app can only process products in the
              store’s default language, as it does not support any third-party
              language translation applications.{" "}
            </Text>
            <Text variant="bodyMd" as="p">
              5. Additionally, product submissions will be restricted to the
              store’s default currency. The Google Shopping Feed app does not
              integrate with currency switcher apps. If you plan to run Shopping
              Campaigns in multiple countries, Google Merchant Center’s currency
              converter will handle the currency conversion. External currency
              conversion tools are not supported by the app.
            </Text>
            <Text variant="bodyMd" as="p">
              6. It is crucial to configure Shipping Settings for every
              additional country in Google Merchant Center. If this step is
              skipped, products may not be approved.{" "}
            </Text>
            <Text variant="bodyMd" as="p">
              7. When adding products for multiple countries, tax settings will
              be consistent across all locations. The price value reflected in
              microdata must remain identical for every country. Even if you do
              not apply taxes in certain regions, the submitted product price
              must match the store’s microdata values to maintain accuracy.
            </Text>
            <Text variant="bodyMd" as="p">
              8. For those adding the United States as an additional country,
              tax settings specific to the USA must be configured within Google
              Merchant Center.{" "}
            </Text>
            <Text variant="bodyMd" as="p">
              9. Ensure that Shipping Settings are configured correctly for each
              additional country within Google Merchant Center.
            </Text>
            <Text variant="bodyMd" as="p">
              10. If you are expanding product submissions to other countries,
              be mindful of your total product submission limit (each product
              variant counts as an individual submission). The current Merchant
              Center quota allows up to 150,000 products. If you receive an
              increased quota from Google, be sure to resync your account after
              the adjustment is applied.
            </Text>
          </div>
        </BlockStack>
      </Card>
    </div>
  );
};

export default MustRead;
